export function composeEventHandlers(e, n) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$checkForDefaultP = _ref.checkForDefaultPrevented,
      t = _ref$checkForDefaultP === void 0 ? !0 : _ref$checkForDefaultP;

  return function (r) {
    if (null == e || e(r), !1 === t || !r.defaultPrevented) return null == n ? void 0 : n(r);
  };
}